module.exports = __webpack_public_path__ + "img/ic_dissatisfied_yellow.72c7a1fb.svg";